import React from "react"
import HomePage from "./components/HomePage"
import WebLayout from "../../components/WebLayout"

const LandingPage = () => {
  return (
    <>
      <WebLayout>
        <HomePage />
      </WebLayout>
    </>
  )
}

export default LandingPage
